import { render, staticRenderFns } from "./AI-Overview.vue?vue&type=template&id=63b6c51e&scoped=true"
import script from "./AI-Overview.vue?vue&type=script&lang=js"
export * from "./AI-Overview.vue?vue&type=script&lang=js"
import style0 from "./AI-Overview.vue?vue&type=style&index=0&id=63b6c51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6c51e",
  null
  
)

export default component.exports